module.exports = __webpack_public_path__ + "img/record.1294fd37.png";